import { create, test, enforce } from 'vest';

const validators = create((data = {}) => {
  test('cardholderName', 'cardholderName can\'t be empty', () => {
    enforce(data.cardholderName).isNotEmpty();
  });

  test('number', 'number can\'t be empty', () => {
    enforce(data.number).isNotEmpty();
  });

  test('cvv', 'cvv can\'t be empty', () => {
    enforce(data.cvv).isNotEmpty();
  });

  test('expirationDate', 'expirationDate can\'t be empty', () => {
    enforce(data.expirationDate).isNotEmpty();
  });
});

export default validators;
